(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aereli-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var root = document.getElementById('shopify-section-{{ section.id }}');
  if (!root) return;
  var band = root.querySelector('.ah-flow');
  if (!band) return;
  var canvas = band.querySelector('.ah-flow-canvas');
  var ctx = canvas.getContext('2d');
  if (!ctx) return;

  var W = 0;
  var H = 0;
  var particles = [];
  var running = false;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var COLORS = ['181,141,130', '216,185,138', '255,255,255'];

  function resize() {
    W = band.clientWidth;
    H = band.clientHeight;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = W * dpr;
    canvas.height = H * dpr;
    canvas.style.width = W + 'px';
    canvas.style.height = H + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function spawn(init) {
    return {
      x: init ? Math.random() * W : -12 - Math.random() * 50,
      y: H * (0.12 + Math.random() * 0.76),
      r: 0.6 + Math.random() * 1.9,
      speed: 0.5 + Math.random() * 1.5,
      amp: 6 + Math.random() * 22,
      freq: 0.008 + Math.random() * 0.02,
      phase: Math.random() * Math.PI * 2,
      alpha: 0.15 + Math.random() * 0.5,
      color: COLORS[Math.floor(Math.random() * COLORS.length)]
    };
  }

  function seed() {
    var count = Math.min(90, Math.max(30, Math.floor(W / 14)));
    particles = [];
    for (var i = 0; i < count; i++) particles.push(spawn(true));
  }

  function draw(t) {
    ctx.clearRect(0, 0, W, H);
    for (var i = 0; i < particles.length; i++) {
      var p = particles[i];
      p.x += p.speed;
      p.phase += p.freq;
      var y = p.y + Math.sin(p.phase) * p.amp;
      var fade = 1;
      if (p.x < p.r) {
        fade = p.x / p.r;
      } else if (p.x > W - p.r) {
        fade = Math.max(0, (W - p.x) / p.r);
      }
      var twinkle = 0.7 + 0.3 * Math.sin(t * 0.002 + p.phase * 6);
      ctx.beginPath();
      ctx.arc(p.x, y, p.r, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(' + p.color + ',' + (p.alpha * fade * twinkle).toFixed(3) + ')';
      ctx.fill();
      if (p.x > W + 20) p.x = -20 - Math.random() * 40;
    }
  }

  function loop(t) {
    if (running) draw(t);
    window.requestAnimationFrame(loop);
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      running = entry.isIntersecting;
    });
  }, { threshold: 0.03 });

  resize();
  if (reduced) {
    seed();
    draw(0);
    return;
  }
  seed();
  observer.observe(band);
  window.addEventListener('resize', function () {
    resize();
    seed();
  });
  window.requestAnimationFrame(loop);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
